<template>
  <div class="tags-view-container">
    <div class="scroll-btn left" v-if="showLeftSlideMore" @click="slideMore('left', 3)"></div>
    <div class="scroll-area">
      <router-link
        ref="tag"
        :class="['tags-view-item', isActive(tag) ? 'active' : '']"
        v-for="(tag, index) in Array.from(visitedViews)"
        :id="'tag' + index"
        :to="{ path: tag.path, query: tag.query }"
        :key="tag.path"
      >
        <div class="tag-icon"></div>
        <div :class="['tag-title', {'is-mac': isMac}]">{{ tag.title }}</div>
        <img class="delete-icon" src="../../assets/images/tag/delete_icon.png" @click.stop="closeViewTags(tag, $event)">
      </router-link>
    </div>
    <div class="scroll-btn right" v-if="showRightSlideMore" @click="slideMore('right', 3)"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      canScroll: false,
      alreadyScroll: false,
      alreadyScrollEnd: false,
      isNewVisited: true,
    };
  },
  computed: {
    ...mapState('app', ['visitedViews']),
    showLeftSlideMore() {
      return this.canScroll && this.alreadyScroll;
    },
    showRightSlideMore() {
      return this.canScroll && !this.alreadyScrollEnd && !this.isNewVisited;
    },
    isMac() {
      return /macintosh|mac os x/i.test(navigator.userAgent);
    },
  },
  mounted() {
    this.addViewTags();
    this.judgeSlideMore();
    const that = this;
    const scrollXContainer = document.querySelector(".scroll-area");
    scrollXContainer.addEventListener("wheel", (event) => {
      event.preventDefault();
      scrollXContainer.scrollLeft += event.deltaY;
      that.isNewVisited = false;
    });
    scrollXContainer.addEventListener("scroll", (event) => {
      event.preventDefault();
      that.judgeSlideMore();
    });
  },
  methods: {
    closeViewTags(view, $event) {
      console.log(view);
      this.$store.dispatch("app/delVisitedViews", view).then((views) => {
        if (this.isActive(view)) {
          const latestView = views.slice(-1)[0];
          if (latestView) {
            this.$router.push(latestView.path);
          } else {
            this.$router.push("/");
          }
        }
      });
      $event.preventDefault();
      this.$nextTick(() => {
        this.judgeSlideMore();
      });
    },
    addViewTags() {
      const route = this.$route.name ? this.$route : false;
      if (!route) return false;
      this.isNewVisited = !this.visitedViews.some(v => v.path === route.path);
      this.$store.dispatch("app/addVisitedViews", route);
      return true;
    },
    isActive(route) {
      return route.path === this.$route.path || route.name === this.$route.name;
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag;
      if (tags) {
        this.$nextTick(() => {
          const curTag = tags.find(item => item.to.path === this.$route.path).$el;
          const scrollXContainer = document.querySelector(".scroll-area");
          const { clientWidth: tagCw, offsetLeft: tagOl } = curTag;
          const { clientWidth: containerCw, scrollLeft } = scrollXContainer;
          // console.log(tagOl, tagCw, containerCw);
          if (tagOl + tagCw > containerCw) { // 在右边，需要左滑
            scrollXContainer.scrollBy({ left: tagCw + tagOl - containerCw, behavior: 'smooth' });
          } else if (tagOl < scrollLeft) { // 在左边，需要右滑
            console.log('tagOl < scrollLeft');
            scrollXContainer.scrollTo({ left: tagOl - 44, behavior: 'smooth' });
          }
        });
      }
    },
    judgeSlideMore() {
      const { clientWidth, scrollWidth, scrollLeft } = document.querySelector(".scroll-area");
      this.canScroll = scrollWidth > clientWidth;
      this.alreadyScroll = scrollLeft > 0;
      this.alreadyScrollEnd = scrollLeft + clientWidth > scrollWidth - 1;
    },
    slideMore(direction, tagNum) {
      this.isNewVisited = false;
      const tagWidth = 162;
      const scrollXContainer = document.querySelector(".scroll-area");
      const { clientWidth, scrollWidth, scrollLeft } = scrollXContainer;
      if (direction === 'left') {
        scrollXContainer.scrollTo({ left: scrollLeft - tagNum * tagWidth, behavior: 'smooth' });
      } else {
        scrollXContainer.scrollTo({ left: scrollLeft + tagNum * tagWidth, behavior: 'smooth' });
      }
    },
  },
  watch: {
    $route() {
      this.addViewTags();
      this.moveToCurrentTag();
      this.$nextTick(() => {
        this.judgeSlideMore();
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.tags-view-container {
  position: sticky;
  top: 0;
  z-index: 99;
  height: 40px;
  overflow: hidden;
  background: #eff4f8;

  .scroll-btn {
    position: absolute;
    top: 0;
    width: 40px;
    height: 40px;
    background-size: cover;

    &.left {
      left: 0;
      background-image: url(../../assets/images/tag/left_slide.png);

      &:hover {
        background-image: url(../../assets/images/tag/left_slide_active.png);
      }
    }

    &.right {
      right: 0;
      background-image: url(../../assets/images/tag/right_slide.png);

      &:hover {
        background-image: url(../../assets/images/tag/right_slide_active.png);
      }
    }
  }

  .scroll-area {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-end;
    width: calc(100% - 80px);
    padding-left: 4px;
    margin-left: 40px;
    overflow-x: scroll;
    overflow-y: hidden;

    .tags-view-item {
      position: relative;
      display: flex;
      align-items: center;
      height: 35px;
      margin-top: 5px;
      margin-right: 4px;
      background: #fff;
      border: 1px solid #cfd5da;
      border-bottom: none;
      border-radius: 12px 12px 0 0;

      .tag-icon {
        width: 12px;
        height: 16px;
        margin-left: 15px;
        background-image: url(../../assets/images/tag/tag_icon.png);
        background-size: cover;
      }

      .tag-title {
        max-width: 126px;
        margin-left: 6px;
        overflow: hidden;
        font-family: "Noto Sans S Chinese", sans-serif;
        font-size: 16px;
        font-weight: 400;

        // line-height: normal;
        color: #8e939d;
        text-overflow: ellipsis;
        word-break: break-all;
        white-space: nowrap;

        &.is-mac {
          transform: translateY(2px);
        }
      }

      .delete-icon {
        width: 14px;
        height: 14px;
        margin-right: 15px;
        margin-left: 15px;

        &:hover {
          transform: scale(1.2);
        }
      }

      &.active {
        .tag-icon {
          background-image: url(../../assets/images/tag/tag_icon_active.png);
        }

        .tag-title {
          color: #008cff;
        }
      }
    }
  }
}
</style>
